export default () => {
    window.dataLayer = window.dataLayer || [];

    const pushToDataLayer = (eventName, eventParams) => {
        window.dataLayer.push({
            event: eventName,
            ...eventParams,
        });
    };

    const handleHubSpotFormSubmission = (e) => {
        const form = e.target.closest('.hbspt-form');
        if (form && form.dataset.analyticssent === undefined) {
            if (e.target.tagName.toLowerCase() === 'input' && e.target.type.toLowerCase() === 'submit') {
                form.dataset.analyticssent = '1';

                pushToDataLayer('page_view', {
                    page_title: document.getElementsByTagName('title')[0].innerHTML,
                    page_location: location.protocol + '//' + location.host + location.pathname + 'thank-you/',
                });
            }
        }
    };

    const initializeEventListeners = () => {
        document.addEventListener('click', handleHubSpotFormSubmission);

        document.body.addEventListener('marketing-form-load', () => {
            pushToDataLayer('HubSpot_interaction', {
                event_category: 'HubSpot',
                event_label: 'Form Opened',
            });
        });

        document.body.addEventListener('marketing-form-submission', () => {
            pushToDataLayer('HubSpot_interaction', {
                event_category: 'HubSpot',
                event_label: 'Form Sent',
            });
        });

        document.body.addEventListener('marketing-info-sent', () => {
            pushToDataLayer('HubSpot_interaction', {
                event_category: 'HubSpot',
                event_label: 'File Downloaded',
            });
        });

        document.addEventListener('wpcf7submit', (event) => {
            if (8207 === event.detail.contactFormId) {
                pushToDataLayer('Quote_request', {
                    event_category: 'Quote',
                    event_label: 'Form Sent',
                });
            }
        });

        document.body.addEventListener('search-request', (e) => {
            pushToDataLayer('Search_request', {
                event_category: 'Search',
                event_label: 'Search Request',
                event_params: {
                    search_term: e.detail.query,
                },
            });
        });
    };

    // Initialize event listeners immediately
    initializeEventListeners();
};
